interface SaveButtonsProps {
  onSaveToCloud: () => void;
  onSaveToDevice: () => void;
  isLoading?: boolean;
}

export default function SaveButtons({ onSaveToCloud, onSaveToDevice, isLoading = false }: SaveButtonsProps) {
  const baseStyle: React.CSSProperties = {
    padding: '12px 20px',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '15px',
    cursor: isLoading ? 'not-allowed' : 'pointer',
    opacity: isLoading ? 0.6 : 1,
    transition: 'background 0.2s',
    flex: '1 1 auto',
  };

  return (
    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
      <button
        type="button"
        onClick={onSaveToCloud}
        disabled={isLoading}
        style={{ ...baseStyle, background: '#4a90e2' }}
      >
        {isLoading ? 'Zapisywanie...' : '☁ Zapisz w chmurze'}
      </button>
      <button
        type="button"
        onClick={onSaveToDevice}
        disabled={isLoading}
        style={{ ...baseStyle, background: '#ff7043' }}
      >
        {isLoading ? 'Zapisywanie...' : '📱 Zapisz na urządzeniu'}
      </button>
    </div>
  );
}
